import { render } from "./NumberManagement.vue?vue&type=template&id=924a6bd0&scoped=true"
import script from "./NumberManagement.vue?vue&type=script&lang=js"
export * from "./NumberManagement.vue?vue&type=script&lang=js"

import "./NumberManagement.vue?vue&type=style&index=0&id=924a6bd0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924a6bd0"]])

export default __exports__